import { Field } from '@headlessui/react';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { Label } from '@/components/form/label';
import { Button } from '@/components/ui/button';
import { SectionHeadingGroup } from '@/components/ui/section-heading-group';
import { useCurrentUnit } from '@/hooks/use-current-unit';
import { api } from '@/redux/api';

interface formInput {
  addressBookName: string;
}

export const CreateAddressBookForm: FC = () => {
  const [createAssignAddressBook] = api.useCreateAssignAddressBookMutation();
  const { register, handleSubmit } = useForm<formInput>();
  const { data: unit } = useCurrentUnit();
  const onSubmit = (data: formInput) =>
    createAssignAddressBook({
      organisationId: unit?.organisation.id ?? -1,
      unitId: unit?.id ?? -1,
      actionType: 'createAssignAddressBook',
      addressBookName: data.addressBookName,
    });

  return (
    <div>
      <SectionHeadingGroup
        className="max-w-96"
        subtitle="Create a new address book and add it to this unit"
        title="Create new address book"
      />
      <form className={'flex flex-col gap-1'} onSubmit={handleSubmit(onSubmit)}>
        <Field className="flex flex-col">
          <Label>Address Book Name: </Label>
          <input
            className={'outline outline-1'}
            {...register('addressBookName')}
          ></input>
        </Field>
        <Button className="place-self-start" type="submit">
          Create Address Book
        </Button>
      </form>
    </div>
  );
};
